module.exports = __webpack_public_path__ + "media/theme/wall__sidebar--itunes-71a4e467.svg";